export default {
  SUPPORT_GROUP_LIST: 'WebsiteSTNHD/SupportGroupList',
  SUPPORT_LIST: 'WebsiteSTNHD/SupportList',
  SUPPORT_SEARCH_LIST: 'WebsiteSTNHD/SupportSearchList',
  SUPPORT_DETAIL: 'WebsiteSTNHD/SupportDetail',
  FEEDBACK: 'WebsiteSTNHD/Feedback',
};
